import React, { useCallback, useState } from "react"
import Beats from "./components/Beats/Beats"
import beats, { bonusBeat } from "shared/constants/beats"
import { HomeBackground } from "./components/HomeBackground/HomeBackground"
import { Title } from "./components/Title/Title"
import Footer from "features/Footer/Footer"

export default function Home() {
  const [playingBeat, setPlayingBeat] = useState(null)

  const stop = useCallback(() => {
    setPlayingBeat(null)
  }, [setPlayingBeat])

  return (
    <HomeBackground>
      <Title />
      <Beats
        playingBeat={playingBeat}
        setPlayingBeat={setPlayingBeat}
        beats={beats}
        bonusBeat={bonusBeat}
        stop={stop}
      />
      <Footer />
    </HomeBackground>
  )
}
